import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

import { reducers } from './reducers';
import { IRootState } from './type';
import { TScheduleShift } from '../../types';

const initialState: IRootState = {
  scheduleList: {},
  selectedShiftDate: null,
  selectedScheduleShift: {} as TScheduleShift,
  isOpenDeleteShiftDialog: false,
  isOpenDayOffNav: false,
  isDisplayPublishBtn: false,
  timeOffs: [],
  isOpenBulkDialog: false,
  isOpenDeleteTimeOffDialog: false,
  selectedLocationId: 0,
  selectedShiftMember: {} as IRootState['selectedShiftMember'],
  selectedStatus: 0,
  isOpenShiftNotesNav: false,
  isOpenCopyShiftsNav: false,
};

export const slice = createSlice({
  name: STORE_SLICES.SCHEDULES,
  initialState,
  reducers,
});

const schedulesActions = slice.actions;

const schedulesPersistConfig = {
  key: PERSIST_KEYS.SCHEDULES,
  storage,
  whitelist: ['scheduleList', 'timeOffs'],
};

export {
  schedulesActions,
};

export default persistReducer(schedulesPersistConfig, slice.reducer);
